import * as React from 'react';
import { PureIconContainer } from './utils/IconContainer';
var Link = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Link_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.307 1.121a3.828 3.828 0 0 1 5.413 0l.159.159a3.829 3.829 0 0 1 0 5.414l-2.48 2.48a.5.5 0 1 1-.707-.707l2.48-2.48a2.829 2.829 0 0 0 0-4l-.159-.159a2.828 2.828 0 0 0-3.999 0l-2.48 2.48a.5.5 0 1 1-.707-.706l2.48-2.48Zm1.047 4.525a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708l4-4a.5.5 0 0 1 .708 0Zm-6.046 1.18a.5.5 0 0 1 0 .707l-2.48 2.48a2.829 2.829 0 0 0 0 4l.159.159a2.828 2.828 0 0 0 3.999 0l2.48-2.48a.5.5 0 1 1 .707.706l-2.48 2.48a3.828 3.828 0 0 1-5.413 0l-.159-.158a3.829 3.829 0 0 1 0-5.414l2.48-2.48a.5.5 0 0 1 .707 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Link_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
export default Link;